import { ALERT_DISMISS, ALERT_SHOW } from './alertActionTypes';

export function showAlert() {
    return async (dispatch) => {
        dispatch({ type: ALERT_SHOW });
    };
}

export function dismissAlert() {
    return (dispatch) => {
        dispatch({ type: ALERT_DISMISS });
    };
}
